import { useState } from 'react'

// TODO: NO Usar, Se eliminará cuando no se use mas
export const useForm = (initialState = {}) => {
   const [values, setValues] = useState(initialState)

   const reset = () => {
      setValues(initialState)
   }

   const handleInputChange = ({ target }) => {
      setValues({
         ...values,
         [target.name]: target.value
      })
   }

   const setForm = (name, val) => {
      if (val !== '') {
         setValues({
            ...values,
            [name]: val
         })
      }
   }

   return [values, handleInputChange, setForm, reset]
}
